import { gql } from "@apollo/client";

export const GET_ASSET_HEAT_INSTALLATION = gql`
    query GetLegacyNextAssetHeatInstallation($bfe: String!) {
        getLegacyNextAssetHeatInstallation(bfe: $bfe) {
            bfe
            heatInstallation
        }
    }
`;
